import { useState } from 'react';

import regexpPatterns from '@/shared/constants/regexpPatterns';

const useCustomsDetails = () => {
  const [customsDetailsForm, setCustomsDetailsForm] = useState({
    source: '',
    email_address: '',
    usmca_number: '',
    fda_number: '',
    fax_extension: '',
    fax_number: '',
  });

  const [brokerForm, setBrokerForm] = useState({
    use_carrier_as_broker: false,
    broker_name: '',
    broker_account_number: '',
    broker_extension: '',
    broker_phone_number: '',
  });

  const [formErrors, setFormErrors] = useState<
    Partial<typeof customsDetailsForm> & Partial<typeof brokerForm>
  >({});

  const onValidate = () => {
    const errors: Partial<typeof customsDetailsForm> &
      Partial<typeof brokerForm> = {};

    if (
      customsDetailsForm.email_address &&
      !regexpPatterns.emailValidator.test(customsDetailsForm.email_address)
    ) {
      errors.email_address = 'Invalid email address';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return {
    customsDetailsForm,
    brokerForm,
    formErrors,
    setBrokerForm,
    setCustomsDetailsForm,
    onValidate,
  };
};

export default useCustomsDetails;
